import React from 'react';
import SolutionDescription from './SolutionDescription';
import "./aboutussection.css";


import Stat_Img from "./../img/stat_img.png"

const AboutUsSection = () => {
  return (
    <div className='aboutussection'>
      <div className='AboutUsSection_block1'>
        <div className='AboutUsSection_block2'>
          <SolutionDescription />
        </div>
        <div className='AboutUsSection_block3'>

          <div>
            <img src={Stat_Img} alt="Background" className='img_section' />

          </div>
        </div>
      </div>
    </div>

  );
};

export default AboutUsSection;

